module.exports = __webpack_public_path__ + "static/media/S1-15-Cretaur-K-cod15.8d4d5476.png";